'use client';

import MLink from '@mui/material/Link';
import { getMapQuery, getMapUrl } from './map-url';
import { makeStyles } from 'tss-react/mui';
import InlineMarkdown from '../inline-markdown';
import PopoverIcon from '../popover-icon';

const useStyles = makeStyles()(() => ({
  compact: {
    display: 'flex',
    alignItems: 'center',
  },
}));

type Props = {
  name?: string;
  address?: string;
  details?: string;
  className?: string;
  mapLinkInNewTab?: boolean;
  [key: string]: unknown;
};

const EventLocationCompact = ({ name, address, details, className, mapLinkInNewTab, ...rest }: Props) => {
  const { classes, cx } = useStyles();

  if (!name && !address) {
    return null;
  }

  const mapQuery = getMapQuery(name, address);
  const mapUrl = getMapUrl(mapQuery);

  return (
    <div className={cx(classes.compact, className)} {...rest}>
      <span>
        {name || address} (
        <MLink
          href={mapUrl}
          title={mapQuery}
          {...(mapLinkInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
        >
          map
        </MLink>
        )
      </span>
      {details && <PopoverIcon><InlineMarkdown>{details}</InlineMarkdown></PopoverIcon>}
    </div>
  );
};

export default EventLocationCompact;
